module.exports = ($scope, $uibModalInstance, workflowStep, starredDoc, Api) ->
  $scope.comment = undefined

  $scope.cancel = ->
    $uibModalInstance.dismiss "cancel"
    return

  $scope.ok = ->
    new_comment = new Api.Comment
      content: $scope.comment
      workflow_step: workflowStep
      document: starredDoc

    new_comment.$save()

    $uibModalInstance.close new_comment
    return

